import React from "react";
import {
  HeaderContainer,
  MainHeader,
  NullDescription,
  NullMessage,
  NullPage,
  ReservationContainer,
} from "./styles";
import { ReservationCard } from "../../components/ReservationCard";
import { getReservationsList } from "../../services/reservations/getReservations";
import Spinner from "../../components/Spinner/Spinner";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/constants";
import { Button } from "@mui/material";
import theme from "../../theme/theme";

const Reservations = () => {
  const navigate = useNavigate();

  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");

  // ------------------- STATES -------------------
  const [loadingReservations, setLoadingReservations] = React.useState(true); // Loading state
  const [reservationsList, setReservationsList] = React.useState<any>([]); // Resources list state

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    if (jwt) {
      setLoadingReservations(true);
      getReservations();
    }
  }, [jwt]);

  React.useEffect(() => {
  }, [reservationsList]);

  // ------------------- GET RESOURCES FROM API -------------------
  const getReservations = async () => {
    try {
      const statuses = ["Pending", "In Progress", "Approved"];
      const allReservations = [];

      for (const status of statuses) {
        const res = await getReservationsList(jwt!, status, "", "");
        if (res && res.data && res.data.length > 0) {
          allReservations.push(...res.data);
        }
      }

      if (allReservations.length > 0) {
        allReservations.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
        setReservationsList(allReservations);
      }
    } catch (err) {
      // Manejar el error aquí
    } finally {
      setLoadingReservations(false);
    }
  };

  // ------------------- FUNCTIONS -------------------

  //   function formatDateString(inputDate: string): { date: string; time: string } {
  //     const dateObj = new Date(inputDate);

  //     const year = dateObj.getFullYear().toString().slice(2);
  //     const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  //     const day = dateObj.getDate().toString().padStart(2, "0");

  //     const date = `${day}/${month}/${year}`;

  //     const hours = dateObj.getHours().toString().padStart(2, "0");
  //     const minutes = dateObj.getMinutes().toString().padStart(2, "0");

  //     const time = `${hours}:${minutes}`;

  //     return { date, time };
  //   }

  function formatDateString(inputDate: string): { date: string; time: string } {
    const dateObj = new Date(inputDate);

    // Establecer la zona horaria a 'America/Mexico_City'
    const timeZone = "America/Mexico_City";

    // Crear una instancia de Intl.DateTimeFormat con la zona horaria deseada
    const dateTimeFormatter = new Intl.DateTimeFormat("es-MX", {
      timeZone,
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

    // Formatear la fecha y hora
    const [
      { value: day },
      ,
      { value: month },
      ,
      { value: year },
      ,
      { value: hour },
      ,
      { value: minute },
    ] = dateTimeFormatter.formatToParts(dateObj);

    const date = `${day}/${month}/${year}`;
    const time = `${hour}:${minute}`;

    return { date, time };
  }

  const statusMapping: { [key: string]: string } = {
    Completed: "Completada",
    "In Progress": "En progreso",
    Pending: "Pendiente",
    Approved: "Aprobada",
    "Not available": "No disponible",
    Rejected: "Denegada",
    Canceled: "Cancelada",
    Modified: "Modificada",
    Expired: "Vencida",
  };

  const handleStatus = (reservationStatus: string): string => {
    return statusMapping[reservationStatus] || "Desconocido";
  };

  return (
    <>
      {!loadingReservations ? (
        <div>
          <HeaderContainer>
            <MainHeader>Mis Reservaciones</MainHeader>
          </HeaderContainer>

          <ReservationContainer>
            {Array.isArray(reservationsList) && reservationsList.length > 0 ? (
              reservationsList.map((reservation: any) => {
                const { date: startDate, time: startTime } = formatDateString(
                  reservation.start
                );
                const { date: endDate, time: endTime } = formatDateString(
                  reservation.finish
                );
                const status = handleStatus(reservation.status);

                return (
                  <ReservationCard
                    key={reservation.id}
                    reservation={{
                      resourceId: reservation.resource,
                      resourceName: reservation.resource_name,
                      startDate: startDate,
                      startTime: startTime,
                      endDate: endDate,
                      endTime: endTime,
                      status: status,
                      reservationId: reservation.id,
                      description: reservation.description,
                    }}
                  />
                );
              })
            ) : (
              <NullPage>
                <NullMessage>No tienes reservaciones</NullMessage>
                <NullDescription>
                  Puedes reservar recursos desde nuestra página de inicio
                </NullDescription>
                <Button
                  variant="contained"
                  onClick={() => navigate(`${ROUTES.RESERVE}`)}
                  sx={{
                    borderRadius: "12px",
                    backgroundColor: theme.color.stone,
                    padding: "5px 10%",
                    marginRight: "15px",
                    color: "#FFF",
                    textTransform: "none",
                    marginTop: "30px",
                    fontSize: "1.05rem",
                    "&:hover": {
                      backgroundColor: theme.color.navy,
                    },
                  }}
                >
                  Reservar
                </Button>
              </NullPage>
            )}
          </ReservationContainer>
        </div>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default Reservations;
